export type DbEnv =
  | "develop_local_dump"
  | "stage_local_dump"
  | "prod_local_dump"
  | "local"
  | "local_test"
  | "docker_test"
  | "sandbox1"
  | "sandbox2"
  | "sandbox3"
  | "sandbox4"
  | "sandbox5"
  | "sandbox6"
  | "sandbox7"
  | "sandbox8"
  | "sandbox9"
  | "sandbox10"
  | "sandbox11"
  | "sandbox12"
  | "sandbox13"
  | "sandbox14"
  | "sandbox15"
  | "sandbox16"
  | "sandbox17"
  | "sandbox18"
  | "sandbox19"
  | "sandbox20"
  | "demo1"
  | "demo2"
  | "pr"
  | "develop"
  | "qa"
  | "stage"
  | "prod";

export const remoteDbs: DbEnv[] = [
  "sandbox1",
  "sandbox2",
  "sandbox3",
  "sandbox4",
  "sandbox5",
  "sandbox6",
  "sandbox7",
  "sandbox8",
  "sandbox9",
  "sandbox10",
  "sandbox11",
  "sandbox12",
  "sandbox13",
  "sandbox14",
  "sandbox15",
  "sandbox16",
  "sandbox17",
  "sandbox18",
  "sandbox19",
  "sandbox20",
  "demo1",
  "demo2",
  "pr",
  "develop",
  "qa",
  "stage",
  "prod",
] as const;

export type SandboxDbEnv = Extract<DbEnv, `sandbox${number}`>;

export const sandboxDbs: SandboxDbEnv[] = remoteDbs.filter((db): db is SandboxDbEnv => db.startsWith("sandbox"));

export type HotfixableEnv = Extract<DbEnv, "demo1" | "demo2" | "stage" | "prod" | "qa">;

export const hotfixableEnvs: HotfixableEnv[] = remoteDbs.filter((db): db is HotfixableEnv =>
  ["demo1", "demo2", "stage", "prod", "qa"].includes(db),
);

/**
 * Environments the daily staff-account sync (FDN-1893) provisions and runs
 * against — every remote env except the shared `demo2` and the ephemeral `pr`.
 * Kept in sync with the `ENVS` list in the `sync-staff-accounts-run` CircleCI
 * job by deriving from `remoteDbs`.
 */
export const staffSyncEnvs: DbEnv[] = remoteDbs.filter((db) => db !== "demo2" && db !== "pr");
